import { textblockTypeInputRule } from 'prosemirror-inputrules';
import { ParseSpec } from 'prosemirror-markdown';
import { NodeSpec } from 'prosemirror-model';

import { BaseExtension, EditorOptions } from '@lyearn/lygo-core';

import { HEADING_REGEX, NODE_NAME } from './consts';
import plugins from './plugins';

export default class Heading extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: { level: { default: 1 } },
      content: 'inline*',
      group: 'block',
      defining: true,
      parseDOM: [
        { tag: 'h1', attrs: { level: 1 } },
        { tag: 'h2', attrs: { level: 2 } },
        { tag: 'h3', attrs: { level: 3 } },
        { tag: 'h4', attrs: { level: 3 } },
        { tag: 'h5', attrs: { level: 3 } },
        { tag: 'h6', attrs: { level: 3 } },
      ],
      toDOM(node) {
        let className = 'text-text-primary ';
        switch (node.attrs.level) {
          case 1:
            className = className + 'mt-36 mb-24 heading-xl';
            break;
          case 2:
            className = className + 'mt-36 mb-16 heading-m';
            break;
          case 3:
            className = className + 'mt-30 heading-s';
            break;
        }
        return ['h' + node.attrs.level, { class: className, id: node.attrs.id }, 0];
      },
    };
  }

  inputRules = ({ schema }: EditorOptions) => {
    //ref: https://github.com/ProseMirror/prosemirror-example-setup/blob/6bd92b0712bf389cfe7ec26904230f959643e60b/src/inputrules.js
    return [
      textblockTypeInputRule(HEADING_REGEX, schema.nodes.heading, (match) => {
        if (match[1]) {
          return {
            level: match[1].length ?? 1,
          };
        }
      }),
    ];
  };

  plugins = plugins;

  get name(): string {
    return NODE_NAME;
  }

  parseMarkdown(): void | ParseSpec {
    return {
      block: NODE_NAME,
      // tok.tag.slice(1) gives us the heading level, e.g. "h1" => 1
      getAttrs: (tok) => ({ level: +tok.tag.slice(1) }),
    };
  }
}
